import type { ScheduleTripRequest, ScheduleTripData } from "@/types/scheduletrip";
import type { PurchaseSummaryData } from "@/types/purchasesummary";
import { apiClient } from "@/api/axios";
import type { ApiResponse } from "@/types/api";
import type { PurchaseSummaryRequest } from "@/types/purchasesummary";
import type { SaveContactRequest, SaveContactData } from "@/types/purchase-ticket/savecontact";
import type { ReserveTripRequest, ReserveTripData } from "@/types/purchase-ticket/reservetrip";
import type { InvoiceRequest, InvoiceData } from "@/types/purchase-ticket/invoice";
import type { ConfirmPurchaseRequest, ConfirmPurchaseData } from "@/types/purchase-ticket/confirmpurchase";
import type { VerifyTdaData, VerifyTdaRequest } from "@/types/purchase-ticket/verifytda";

/* Purchase Ticket Search  */
export async function SearchTrip(payload: ScheduleTripRequest) {
  const { data } = await apiClient.post<ApiResponse<ScheduleTripData>>(
    "/api/AgentBooking/search_trip",
    payload,
  );
  
  if (!data.status) {
    throw new Error(data.message ?? "Search trip failed");
  }

  return data;
}

/* Reserve Trip */
export async function ReserveTrip(payload: ReserveTripRequest) {
  const { data } = await apiClient.post<ApiResponse<ReserveTripData>>(
    "/api/AgentBooking/reserve_trip",
    payload,
  );
  
  if (!data.status) {
    throw new Error(data.message ?? "Reserve trip failed");
  }

  return data;
}

/* Save Contact */
export async function SaveContact(payload: SaveContactRequest) {
  const { data } = await apiClient.post<ApiResponse<SaveContactData>>(
    "/api/AgentBooking/save_contact",
    payload,
  );

  if (!data.status) {
    throw new Error(data.message ?? "Save contact failed");
  }

  return data;
}

/* Get Invoice */
export async function GetInvoice(payload: InvoiceRequest) {
  const { data } = await apiClient.post<ApiResponse<InvoiceData>>(
    "/api/AgentBooking/get_invoice",
    payload,
  );
  
  if (!data.status) {
    throw new Error(data.message ?? "Get invoice failed");
  }

  return data;
}

/* Confirm Purchase */
export async function ConfirmPurchase(payload: ConfirmPurchaseRequest) {
  const { data } = await apiClient.post<ApiResponse<ConfirmPurchaseData>>(
    "/api/AgentBooking/confirm_purchase",
    payload,
  );
  
  if (!data.status) {
    throw new Error(data.message ?? "Confirm purchase failed");
  }

  return data;
}

/* Get Purchase Summary */
export async function GetPurchaseSummary(payload: PurchaseSummaryRequest) {
  const { data } = await apiClient.post<ApiResponse<PurchaseSummaryData>>(
    "/api/AgentBooking/get_summary",
    payload,
  );
  
  if (!data.status) {
    throw new Error(data.message ?? "Get purchase summary failed");
  }

  return data;
}


export async function VerifyTda(payload: VerifyTdaRequest) {
  const { data } = await apiClient.post<ApiResponse<VerifyTdaData>>(
    "/api/AgentBooking/verify_tda",
    payload,
  );
  
  if (!data.status) {
    throw new Error(data.message ?? "Verify TDA failed");
  }

  return data;
}